import { render, staticRenderFns } from "./HealthCertificate.vue?vue&type=template&id=670020ba&scoped=true"
import script from "./HealthCertificate.vue?vue&type=script&lang=js"
export * from "./HealthCertificate.vue?vue&type=script&lang=js"
import style0 from "./HealthCertificate.vue?vue&type=style&index=0&id=670020ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670020ba",
  null
  
)

export default component.exports